// converts a state name (e.g. "New York") into a URL-safe slug (e.g. "new-york")

const slugify = (name) =>
    name
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

export default slugify;
